import React, { useContext, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setRPack } from "../../redux/slices/packSlice";
import { setUser } from "../../redux/slices/userSlice";
import { ThemeContext } from "../../context/ThemeStore";
import { getJsCookieTokenOptions, getTokenCookieBaseOptions } from "../../utils/tokenCookieOptions";

const UserAuthProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { setIsDarkTheme } = useContext(ThemeContext);
  const { testId, packId } = useParams();

  const isTestPage = packId && testId;
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("t");
  const lms = queryParams.get("lms");
  const currentToken = Cookies.get("token");
  const isTokenSame = currentToken === token;
  const tokenCookieBaseOptions = getTokenCookieBaseOptions();

  // Save redirect URL function - call this BEFORE any logout
  const saveRedirectUrl = () => {
    const currentPath = window.location.pathname + window.location.search;
    // Only save if it's not already an auth route and not already set
    if (!currentPath.includes("/auth/")) {
      localStorage.setItem("redirect_url", currentPath);
    }
  };

  const doLogout = () => {
    // Save redirect URL BEFORE clearing anything
    saveRedirectUrl();

    // Clear all auth-related data
    dispatch(setRPack(null));
    dispatch(setUser(null)); // Also clear user from Redux

    localStorage.removeItem("userProfile");
    localStorage.removeItem("recentPack");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("lms"); // Also clear lms if needed
    // Clear both legacy host-only cookie and new domain-level cookie
    Cookies.remove("token");
    Cookies.remove("token", tokenCookieBaseOptions);

    navigate("/auth/login");
  };

  // Set LMS if present in query params
  if (lms) {
    sessionStorage.setItem("lms", lms);
  }

  useEffect(() => {
    const fetchUser = async () => {
      try {
        let request;

        if (token && !isTokenSame) {
          sessionStorage.setItem("token", token);
          localStorage.removeItem("userProfile");
          if (isTestPage) {
            saveRedirectUrl();
            dispatch(setRPack(null));
            localStorage.removeItem("recentPack");
          }
          request = await axios.get("/api/auth/user", {
            headers: { Authorization: `Bearer ${token}` },
          });
          Cookies.set("token", token, getJsCookieTokenOptions());
        } else {
          request = await axios.get("/api/auth/user");
        }

        if (!request || !request.data?.data) {
          saveRedirectUrl(); // Save URL before logout
          doLogout();
        } else {
          dispatch(setUser(request.data?.data));
          setIsDarkTheme(request.data?.data?.settings?.isDarkTheme);
        }
      } catch (error) {
        console.error("Auth error:", error);
        saveRedirectUrl(); // Save URL before logout
        doLogout();
      }
    };

    fetchUser();
  }, [token, isTokenSame, isTestPage]); // Added dependencies

  return <div></div>;
};

export default UserAuthProfile;
